module.exports = __webpack_public_path__ + "static/img/Dream-08.02907c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Dream House/Dream-08.jpg
// module id = Gfqb
// module chunks = 7